import {
    SET_GLOBAL_SEARCH, SET_BREADCRUMB_REDIRECT_STATUS
} from './types';

const reducers = (state: any = {}, action: any) => {
    switch (action.type) {
        case SET_GLOBAL_SEARCH: {
            let globalsearch = state?.globalsearch ?? {};
            globalsearch = { ...globalsearch, ...action.globalSearchValues };
            return {
                ...state, globalsearch
            };
        }
        case SET_BREADCRUMB_REDIRECT_STATUS: {
            return {
                ...state, BreadcrumbValues: action.BreadCrumbRedirectPrameter
            }
        }
        default:
            return state;
    }
};

export default reducers;




